import React, { FunctionComponent, useState } from 'react';
import { View } from '@upstox/upstox-ui';
import useCurrentWidth from '../../hooks/useCurrentWidth';
import Modal from '../Modal/modal';
import Drawer from '../Drawer/drawer';
interface Props {
  title: string;
  show: boolean;
  onClose: () => void;
  zIndex?: number;
}

const InfoPopup: FunctionComponent<Props> = ({
  title,
  show = false,
  onClose,
  children,
  zIndex = 11,
}) => {
  return (
    <>
      {useCurrentWidth() >= 768
        ? show && (
            <Modal
              header={{
                title: title,
              }}
              onClose={onClose}
              zIndex={1}
              className="max-w-100"
            >
              {children}
            </Modal>
          )
        : show && (
            <Drawer
              title={title}
              withCloseButton={false}
              onClose={onClose}
              style={{
                height: 'auto',
              }}
              zIndex={zIndex}
            >
              <div className="pl15 pr15 mb20 full-width">{children}</div>
            </Drawer>
          )}
    </>
  );
};

export default InfoPopup;
